import { type FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'hooks/contexts/AuthContext';
import { RoleEnum } from 'enums/RoleEnum';
import { EnerseeDesignSystem } from 'components/examples/EnerseeDesignSystem';

const EnerseeDesignSystemPage: FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (user?.role !== RoleEnum.SYSADMIN) {
      navigate('/app/not-found');
    }
  }, [user, navigate]);

  // Only render if user is sysadmin
  if (user?.role !== RoleEnum.SYSADMIN) {
    return null;
  }

  return <EnerseeDesignSystem />;
};

export default EnerseeDesignSystemPage;
